import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { uploadEvent } from '@/api/goods/statistics';
let ShareModel = class ShareModel extends Vue {
    close() {
        this.$emit('update:showDist', false);
    }
    cancel() {
        window.localStorage.setItem('__ActivityId', this.ActivityId);
        this.$emit('update:showDist', false);
    }
    async follow() {
        await uploadEvent.init();
        let skuId = this.limitData.url.match(/selectSkuId=([^&.]*)/)[1] || '';
        await uploadEvent.sendRecord('Click_Scholarship_ThresholdGoods_Buy', '', {
            Time: new Date().format('YYYY-MM-DD hh:mm:ss'),
            SkuID: skuId,
        }, [
            ['p1', 'Time'],
            ['p2', 'SkuID'],
        ]);
        window.location.href = this.limitData.url;
    }
};
tslib_1.__decorate([
    Prop()
], ShareModel.prototype, "ActivityId", void 0);
tslib_1.__decorate([
    Prop()
], ShareModel.prototype, "limitData", void 0);
ShareModel = tslib_1.__decorate([
    Component
], ShareModel);
export default ShareModel;
